const digitsOnly = (value: string): string => value.replace(/\D/g, '');

export const isPhoneComplete = (phone?: string | null): boolean =>
  digitsOnly(phone ?? '').length >= 11;

export const isEmailComplete = (email?: string | null): boolean => {
  const normalized = (email ?? '').trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized);
};

export const hasCompleteContacts = (
  phone?: string | null,
  email?: string | null,
): boolean => isPhoneComplete(phone) && isEmailComplete(email);

export const formatPhoneDisplay = (phone?: string | null): string => {
  const digits = digitsOnly(phone ?? '');
  if (digits.length === 11 && (digits.startsWith('7') || digits.startsWith('8'))) {
    const normalized = digits.startsWith('8') ? `7${digits.slice(1)}` : digits;
    return `+7 (${normalized.slice(1, 4)}) ${normalized.slice(4, 7)}-${normalized.slice(7, 9)}-${normalized.slice(9, 11)}`;
  }
  return (phone ?? '').trim() || ' - ';
};

export const formatEmailDisplay = (email?: string | null): string =>
  (email ?? '').trim() || ' - ';
